import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { XE_PREFIX_URL } from './constants/config.xe'

const ListPage = lazy(() => import('./pages/ListPage.QuanLyXe'))

const XeRouters: AppRouterItem[] = [
  {
    path: XE_PREFIX_URL,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPage />
      </LoadingLazyComponents>
    ),
  },
]

export default XeRouters
